export default "__VITE_ASSET__D6asD6j7__"